/**
 * «Что нового»: последние записи CHANGELOG человеческими словами.
 *
 * Тестер заметил, что названия в заголовках поменялись, и не понял
 * почему. Это была наша правка терминологии, и записана она была —
 * в CHANGELOG, который игрок не читает и не должен.
 *
 * Здесь не пересказ CHANGELOG, а то, что заметит человек за столом:
 * без номеров решений, путей к файлам и слов вроде «журнал» или
 * «свёртка». Без уведомлений и значков — просто место, куда можно
 * заглянуть.
 *
 * Тексты лежат в словарях (`whatsNew.items.*` в `i18n.ts`), как
 * и всё остальное на экране (D11): здесь только версии и ключи.
 *
 * Свежая запись обязана совпадать с версией приложения: это держит
 * тест (`whats-new.test.ts`), иначе экран тихо устаревает с первого же
 * выпуска.
 */

export type WhatsNewEntry = {
  readonly version: string
  readonly date: string
  /** Ключи `whatsNew.items.*`: по строке на перемену. */
  readonly items: readonly string[]
}

export const WHATS_NEW: readonly WhatsNewEntry[] = [
  {
    version: '0.4.12',
    date: '2026-10-18',
    items: ['v0_4_12_1', 'v0_4_12_2', 'v0_4_12_3'],
  },
  {
    version: '0.4.11',
    date: '2026-10-08',
    items: ['v0_4_11_1', 'v0_4_11_2', 'v0_4_11_3', 'v0_4_11_4', 'v0_4_11_5'],
  },
  {
    version: '0.4.10',
    date: '2026-10-07',
    items: ['v0_4_10_1', 'v0_4_10_2', 'v0_4_10_3', 'v0_4_10_4', 'v0_4_10_5'],
  },
  {
    version: '0.4.9',
    date: '2026-10-07',
    items: ['v0_4_9_1', 'v0_4_9_2', 'v0_4_9_3'],
  },
  {
    version: '0.4.8',
    date: '2026-10-07',
    items: ['v0_4_8_1'],
  },
]
